/*                                      */

/**
 *
 *
 */
export const VERSION = '5.19.1';
export const PUBLIC_VERSION = '5';
